// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"901":"0a350b86","960":"0a350b86","5703":"0a350b86"}[chunkId] + ".chunk.css";
};